module.exports = __webpack_public_path__ + "static/media/background-description.172eda70.png";